import { useListCustomersApiV1CustomersGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { CustomerListItem } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export const CUSTOMER_MIN_QUERY_LENGTH = 2
const DEBOUNCE_MS = 250
const SUGGEST_LIMIT = 20

export function useCustomerSearch(
  query: string,
  options?: { enabled?: boolean },
) {
  const debouncedQuery = useDebouncedValue(query.trim(), DEBOUNCE_MS)
  const hasQuery = debouncedQuery.length >= CUSTOMER_MIN_QUERY_LENGTH
  const enabled = (options?.enabled ?? true) && hasQuery
  const { data, isFetching } = useListCustomersApiV1CustomersGet(
    { q: debouncedQuery, size: SUGGEST_LIMIT },
    { query: { enabled } },
  )
  const items: CustomerListItem[] = data?.data.items ?? []
  return {
    items,
    isLoading: isFetching && enabled,
    needsMoreInput: !hasQuery,
  }
}
